(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cc-collection-list-manifesto"] && !Shopify.designMode) return;
  try {
    
  class CcClManifestoParallax extends HTMLElement {
    connectedCallback() {
      this._enabled = this.dataset.parallaxEnabled === 'true';
      this._reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this._ticking = false;
      this._container = this.parentElement;

      if (this._enabled && !this._reducedMotion && this._container) {
        this._boundScroll = this._onScroll.bind(this);
        window.addEventListener('scroll', this._boundScroll, { passive: true });
        this._onScroll();
      }
    }

    disconnectedCallback() {
      if (this._boundScroll) {
        window.removeEventListener('scroll', this._boundScroll);
        this._boundScroll = null;
      }
    }

    _onScroll() {
      if (this._ticking) {
        return;
      }
      this._ticking = true;
      window.requestAnimationFrame(() => {
        this._update();
        this._ticking = false;
      });
    }

    _update() {
      if (!this._container) {
        return;
      }

      const rect = this._container.getBoundingClientRect();
      const viewportHeight = window.innerHeight || document.documentElement.clientHeight;
      const total = viewportHeight + rect.height;

      if (total <= 0) {
        return;
      }

      let progress = (viewportHeight - rect.top) / total;
      progress = Math.min(1, Math.max(0, progress));

      const rawOffset = (progress - 0.5) * rect.height * 0.18;
      const maxOffset = rect.height * 0.1;
      const clamped = Math.min(maxOffset, Math.max(-maxOffset, rawOffset));

      this.style.transform = 'translateY(' + clamped.toFixed(2) + 'px)';
    }
  }

  if (!customElements.get('cc-cl-manifesto-parallax')) {
    customElements.define('cc-cl-manifesto-parallax', CcClManifestoParallax);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cc-collection-list-testimonials"] && !Shopify.designMode) return;
  try {
    
  class CcClTestimonialsCarousel extends HTMLElement {
    constructor() {
      super();
      this.currentIndex = 0;
      this.userPaused = false;
      this.autoplayTimer = null;
      this.touchStartX = null;
      this.touchCurrentX = null;
      this.prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      this.handlePrev = this.handlePrev.bind(this);
      this.handleNext = this.handleNext.bind(this);
      this.handleTogglePlay = this.handleTogglePlay.bind(this);
      this.handleDotClick = this.handleDotClick.bind(this);
      this.handlePauseInteraction = this.handlePauseInteraction.bind(this);
      this.handleResumeInteraction = this.handleResumeInteraction.bind(this);
      this.handleFocusOut = this.handleFocusOut.bind(this);
      this.handleTouchStart = this.handleTouchStart.bind(this);
      this.handleTouchMove = this.handleTouchMove.bind(this);
      this.handleTouchEnd = this.handleTouchEnd.bind(this);
    }

    connectedCallback() {
      this.slideCount = parseInt(this.dataset.slideCount, 10) || 0;
      this.autoplayEnabled = this.dataset.autoplay === 'true';
      const speedSeconds = parseInt(this.dataset.autoplaySpeed, 10) || 6;
      this.autoplaySpeed = speedSeconds * 1000;

      this.track = this.querySelector('.cc-cl-testimonials__track');
      this.slides = Array.from(this.querySelectorAll('.cc-cl-testimonials__slide'));
      this.prevButton = this.querySelector('[data-action="prev"]');
      this.nextButton = this.querySelector('[data-action="next"]');
      this.playPauseButton = this.querySelector('[data-action="toggle-play"]');
      this.dots = Array.from(this.querySelectorAll('.cc-cl-testimonials__dot'));
      this.dotsContainer = this.querySelector('.cc-cl-testimonials__dots');

      if (!this.track || this.slides.length === 0) {
        return;
      }

      this.prevButton?.addEventListener('click', this.handlePrev);
      this.nextButton?.addEventListener('click', this.handleNext);
      this.playPauseButton?.addEventListener('click', this.handleTogglePlay);
      this.dotsContainer?.addEventListener('click', this.handleDotClick);

      this.addEventListener('mouseenter', this.handlePauseInteraction);
      this.addEventListener('mouseleave', this.handleResumeInteraction);
      this.addEventListener('focusin', this.handlePauseInteraction);
      this.addEventListener('focusout', this.handleFocusOut);

      this.track.addEventListener('touchstart', this.handleTouchStart, { passive: true });
      this.track.addEventListener('touchmove', this.handleTouchMove, { passive: true });
      this.track.addEventListener('touchend', this.handleTouchEnd);

      this.renderActiveSlide(false);

      if (this.autoplayEnabled && !this.prefersReducedMotion && this.slideCount > 1) {
        this.startAutoplay();
        this.setPlayPauseState(false);
      } else {
        this.setPlayPauseState(true);
      }
    }

    disconnectedCallback() {
      this.stopAutoplay();

      this.prevButton?.removeEventListener('click', this.handlePrev);
      this.nextButton?.removeEventListener('click', this.handleNext);
      this.playPauseButton?.removeEventListener('click', this.handleTogglePlay);
      this.dotsContainer?.removeEventListener('click', this.handleDotClick);

      this.removeEventListener('mouseenter', this.handlePauseInteraction);
      this.removeEventListener('mouseleave', this.handleResumeInteraction);
      this.removeEventListener('focusin', this.handlePauseInteraction);
      this.removeEventListener('focusout', this.handleFocusOut);

      this.track?.removeEventListener('touchstart', this.handleTouchStart);
      this.track?.removeEventListener('touchmove', this.handleTouchMove);
      this.track?.removeEventListener('touchend', this.handleTouchEnd);
    }

    handlePrev() {
      this.goToSlide(this.currentIndex - 1, true);
    }

    handleNext() {
      this.goToSlide(this.currentIndex + 1, true);
    }

    handleDotClick(event) {
      const dot = event.target.closest('.cc-cl-testimonials__dot');
      if (!dot || !this.dotsContainer || !this.dotsContainer.contains(dot)) {
        return;
      }
      const targetIndex = parseInt(dot.dataset.dotIndex, 10) || 0;
      this.goToSlide(targetIndex, true);
    }

    handleTogglePlay() {
      if (this.prefersReducedMotion) {
        return;
      }

      if (this.userPaused) {
        this.userPaused = false;
        if (!this.prefersReducedMotion) {
          this.startAutoplay();
        }
        this.setPlayPauseState(false);
      } else {
        this.userPaused = true;
        this.stopAutoplay();
        this.setPlayPauseState(true);
      }
    }

    handlePauseInteraction() {
      this.stopAutoplay();
      if (this.track) {
        this.track.setAttribute('aria-live', 'polite');
      }
    }

    handleResumeInteraction() {
      if (!this.userPaused && this.autoplayEnabled && !this.prefersReducedMotion) {
        this.startAutoplay();
      }
    }

    handleFocusOut(event) {
      if (event.relatedTarget && this.contains(event.relatedTarget)) {
        return;
      }
      this.handleResumeInteraction();
    }

    handleTouchStart(event) {
      this.touchStartX = event.touches[0].clientX;
      this.touchCurrentX = this.touchStartX;
    }

    handleTouchMove(event) {
      this.touchCurrentX = event.touches[0].clientX;
    }

    handleTouchEnd() {
      if (this.touchStartX === null || this.touchCurrentX === null) {
        return;
      }

      const deltaX = this.touchCurrentX - this.touchStartX;
      const threshold = 40;

      if (deltaX > threshold) {
        this.goToSlide(this.currentIndex - 1, true);
      } else if (deltaX < -threshold) {
        this.goToSlide(this.currentIndex + 1, true);
      }

      this.touchStartX = null;
      this.touchCurrentX = null;
    }

    startAutoplay() {
      this.stopAutoplay();

      if (this.slideCount <= 1) {
        return;
      }

      if (this.track) {
        this.track.setAttribute('aria-live', 'off');
      }

      this.autoplayTimer = window.setInterval(() => {
        this.goToSlide(this.currentIndex + 1, false);
      }, this.autoplaySpeed);
    }

    stopAutoplay() {
      if (this.autoplayTimer) {
        window.clearInterval(this.autoplayTimer);
        this.autoplayTimer = null;
      }
    }

    goToSlide(index, isManual) {
      if (this.slideCount === 0) {
        return;
      }

      const normalized = ((index % this.slideCount) + this.slideCount) % this.slideCount;
      this.currentIndex = normalized;
      this.renderActiveSlide(true);

      if (isManual && this.track) {
        this.track.setAttribute('aria-live', 'polite');
      }
    }

    renderActiveSlide(animate) {
      this.slides.forEach((slide, index) => {
        const isActive = index === this.currentIndex;
        slide.classList.toggle('cc-cl-testimonials__slide--active', isActive);

        if (isActive) {
          slide.removeAttribute('aria-hidden');
        } else {
          slide.setAttribute('aria-hidden', 'true');
        }
      });

      this.dots.forEach((dot, index) => {
        const isActive = index === this.currentIndex;
        dot.classList.toggle('cc-cl-testimonials__dot--active', isActive);
        dot.setAttribute('aria-current', isActive ? 'true' : 'false');
      });

      if (!this.track) {
        return;
      }

      this.track.style.transitionDuration = animate && !this.prefersReducedMotion ? '' : '0s';

      const offset = this.currentIndex * -100;
      this.track.style.transform = `translate3d(${offset}%, 0, 0)`;
    }

    setPlayPauseState(isPaused) {
      if (!this.playPauseButton) {
        return;
      }

      this.playPauseButton.setAttribute('aria-pressed', isPaused ? 'true' : 'false');
      this.playPauseButton.setAttribute(
        'aria-label',
        isPaused ? 'Play testimonial autoplay' : 'Pause testimonial autoplay'
      );
    }
  }

  if (!customElements.get('cc-cl-testimonials-carousel')) {
    customElements.define('cc-cl-testimonials-carousel', CcClTestimonialsCarousel);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);
  
  class StaticHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }
  }

  customElements.define('static-header', StaticHeader);

  } catch(e) { console.error(e); }
})();
})();
